<template>
  <div>
    <div class="wrapper wrapper-content animated fadeInUp">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-content">
              <div v-if="task && task.project">
                <project-header :task-view="true" :project="task.project"></project-header>
              </div>
              <div class="row m-t-sm">
                <task-content></task-content>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectHeader from '../../Projects/Single/Header/Header.vue'
import TaskContent from './Content/Content.vue'
import { useTaskStore } from '../../../../../stores/TaskStore'
import { storeToRefs } from 'pinia'
import { useDataStore } from '../../../../../stores/DataStore'

export default {
  setup () {
    const store = useTaskStore()
    const data = useDataStore()
    data.loadDataStructures(['projectmanager-task-statuses', 'projectmanager-task-priorities', 'departments'])
    const { task } = storeToRefs(store)
    return { store, task, data }
  },
  components: {
    projectHeader: ProjectHeader,
    taskContent: TaskContent
  },
  computed: {
    // ...mapState(useTaskStore, {
    //   getTask: 'getTask'
    // })
  },
  mounted () {
    this.store.loadTask(this.$route.params.id).then((r) => {
      document.title = this.task.title + ' :: Task :: PBN360 by Aphex Media'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/Single/Task.vue